import {useQuery} from '@tanstack/react-query';
import {parseErrors} from 'src/app/utilities/helpers/errors';
import Toaster from 'src/app/utilities/helpers/Toaster';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import {fetchEventTicketSalesCaps} from 'src/data/services/eventService';

type Options = {
    enabled: boolean;
};

export const FETCH_EVENT_TICKET_SALES_CAPS_QUERY_KEY = 'FETCH_EVENT_TICKET_SALES_CAPS';

export const useFetchEventTicketSalesCaps = (
    id: string,
    fetchOptions: BaseFetchOptions,
    options?: Options
) => {
    return useQuery({
        queryKey: [FETCH_EVENT_TICKET_SALES_CAPS_QUERY_KEY, id, fetchOptions],
        queryFn: () => fetchEventTicketSalesCaps(id, fetchOptions),
        onError: (e) => {
            Toaster.toastErrors(parseErrors(e));
        },
        ...options,
        enabled: !!id,
    });
};
